<template>
    <div class="d-lg-flex p-0">
        <div class="col-lg-4 col-md-12">
            <div class="shadow card borderradius10  mb-3"  v-for="(job, index) in jobsList" :key="index">
                <div class="p-2  d-flex" :class="{'borderleftblue': index === 0}">      
                    <div >
                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-2 text-center">
                            <img src="../assets/Profile_placehlder.svg" class="img-fluid rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="pl-0">
                        <div class="d-flex justify-content-between">
                            <div @click="NavToJobDetails">
                                <span class="fontsize24 black proximanova-semibold mt-lg-2 pointer" >{{job.jobTitle}}</span>                                        
                            </div>                           
                        </div>
                        <div class="d-flex flex-column ">
                            <span class="fontsize16 black proximanova">{{job.companyName}}</span>
                            <div>
                                <span class="fontsize14 black60 proximanova">{{job.city}}</span>
                                    
                                <span class="fontsize14 black60 proximanova">{{job.country}}</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="mt-1">
                                <span class="fontsize14 black  proximanova-semibold">1d ago</span>
                                <span class="fontsize12 black60 proximanova mt-1"> - Hiring with in 7 days</span>                                
                            </div>
                        </div> 
                        <div class="d-flex justify-content-between">
                            <div class="mt-1 mb-3">
                                <span class=" p-1 backgroundcolor6 borderradius10 bordergreen mt-1 proximanova fontsize12 green  mr-1">1d ago  </span>
                                <span class="proximanova fontsize12 black60 pl-1"> 39 Applications </span> 
                                
                            </div>
                        </div> 
                    </div>
                </div>
                    
            </div>
        </div>
        <div class="col-lg-8 col-md-12  d-none d-md-none d-lg-block">
            <selecetd-job-deatils></selecetd-job-deatils>
            <!-- <div class="shadow card borderradius10  mb-3"  :key="index">
                <div class="pl-4 pt-4 mb-1 d-flex">   
                    <div class="col-1  p-lg-2 borderradius10 mr-2 mt-2 text-center">
                        <img src="../assets/Profile_placehlder.svg" class="img-fluid rounded-circle" alt="">
                    </div>
                    <div class="col-10 pt-2">
                        <div class="d-flex justify-content-between">
                            <span class="fontsize24 black proximanova stylebold">Product Designer</span>                          
                        </div>
                        <div class="d-flex flex-column mt-2">
                            <span class="fontsize16 black proximanova">Worknotion</span>
                            <div>
                                <span class="fontsize16 black60 proximanova">Proffesional Network services</span>
                                <span class="ml-2 mr-2 black60">|</span>
                                <span class="fontsize16 black60 proximanova">USA</span>
                            </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                            <div class="mt-1">
                                <span class="fontsizemd black stylebold proximanova">1d ago</span>
                                <span class="ml-2 mr-2 black60">|</span>
                                <span class="forgot-password">39 Candidates Applied</span>
                            </div>                            
                        </div>
                        <div class="d-flex   justify-content-between">
                            <div class="d-flex flex-column  mb-2 pt-2 justify-content-between">
                                <div class="row mt-2 ml-0 d-flex "  >
                                    <div  v-for="(item1,index1) in followersProfilePictures" :key="index1" class="d-flex">
                                        <div  class="">                                                        
                                            <img :src="item1" class="img-fluid rounded-circle" id="followImage">                                                                        
                                        </div>                                          
                                    </div> 
                                    <span class="proximanova fontsize10 black60 ml-1 mt-2">5+ followers works here</span>                                                           
                                </div> 
                            </div>
                            <div class="pt-2">
                                <button class="btn button-cancel11 mr-2 navtoPage proximanova">Save</button>
                                <button class="btn sign-up-button enableButton fontsizemd proximanova">Apply</button>
                            </div>
                                                
                        </div>
                    </div>
                </div>
                <hr class="profhoriz">
                <div class="col-12 p-3">
                    <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                            <img src="../assets/EmpType.svg" alt="">
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black60 proximanova">Employment Type</span>
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black proximanova">Full Time</span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                            <img src="../assets/Seniority.svg" alt="">
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black60 proximanova">Seniority</span>
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black proximanova">Mid Senior</span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                            <img src="../assets/PayScale.svg" alt="">
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black60 proximanova">Pay Scale</span>
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black proximanova">$ 12,000 - $ 20,000</span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                            <img src="../assets/PayScale.svg" alt="">
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black60 proximanova">Job Location</span>
                        </div>
                        <div class="col-4">
                            <span class="fontsizemd black proximanova">Boston, USA, 02101.</span>
                        </div>
                    </div>
                    
                </div>
                <hr class="profhoriz">
                <div class="col-12">
                    <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Job Description</span>
                        <span class="fontsizemd proximanova black mb-3 lineheight22">Worknotion is looking for a passionate product designer with 3+ years of interaction design experience. who is passionate to solve complex business problems through design thinking and who will work closely with the product team creating meaningful user experience.</span>
                    </div>
                    <div class="horizontalline mt-1 mb-2"></div>
                </div>
                <div class="col-12">
                    <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Skills Required</span>
                        <div class="row no-gutters mt-2 ml-0">
                            <div v-if="addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in addedSkillsList" :key="index" >
                                    <div class="pl-3 pr-3 p-1 mr-3 borderblue blue fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                        {{skill}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="horizontalline mt-3 mb-3"></div>
                </div>
                <div class="col-12">
                    <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">More Details</span>
                        <span class="fontsizemd proximanova black mb-3 lineheight22">Screening Questions.</span>
                        <span class="fontsizemd proximanova black60 mb-3 lineheight22">Any screening questions added will appear once you click Apply.</span>
                    </div>
                </div>
                <div class="horizontalline mt-1 mb-2" ></div>         
                <div class="col-12">
                    <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-3">
                        <span class="fontsize16 stylebold proximanova black mb-2">About the Company</span>
                        <div class="d-flex mt-2">
                            <div class="">
                                <img src="../assets/Profile_placehlder.svg" oncontextmenu="return false" class="profile-border img-fluid rounded-circle profileimgad" id="profImage">
                            </div>
                            <div class="d-flex flex-column col-10 ">
                                <div class="d-flex justify-content-between">
                                    <span class="font32">WorkNotion</span>
                                    <button class="btn button-cancel11 mr-2 navtoPage" style="height:35px">Follow</button>
                                </div>
                                <div class="d-flex">
                                    <span class="fontsize16 black60 proximanova">Software Product</span>
                                    <span class="ml-2 mr-2 black60">|</span>
                                    <span class="fontsize16 black60 proximanova">India</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col-1"></div>
                            <div class="col-10">
                                <span class="fontsizemd proximanova black">Syntrino is a trusted IT outsourcing company to address the critical need for startups, product companies, and global enterprise. Our product engineers and programmers develop a software platform rich with innovation that helps businesses to edge out the competition and grow sustainably.</span>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col-1"></div>
                            <div class="col-10">
                                <div class="row ">     
                                    <div class="mt-2 count">       
                                        <div class="row m-0">       
                                            <div class="col-3 mr-3">
                                                <label class="font14bold">Followers</label>
                                                <label class="font14bold">5800</label>
                                            </div>
                                            <div class="col-3">
                                                <label class="font14bold">Following</label>
                                                <label class="font14bold">5800</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                <div >
                    <video height="320" oncontextmenu="return false" :src="savedIntroVideoLink" controlsList="nodownload"  id="introVideo" > </video>
                </div>  
                <div class="col-12 mb-4" >
                      <label class="fontsize14 black stylebold proximanova ml-3">More Details</label>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Contact Number</span>
                        </div>
                        <div class="col-4">
                          
                          <span class="fontsize14 black proximanova" >+91 (938) 126-3916</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Company Size</span>
                        </div>
                        <div class="col-4">
                          
                          <span class="fontsize14 black proximanova" >11- 50 employees</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Industry</span>
                        </div>
                        <div class="col-4">
                         
                          <span class="fontsize14 black proximanova" >Software Product</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Founded</span>
                        </div>
                        <div class="col-4">
                          
                          <span class="fontsize14 black proximanova" >2014</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Specialities</span>
                        </div>
                        <div class="col-4">
                          
                          <span class="fontsize14 black proximanova" >Test specialities</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Type</span>
                        </div>
                        <div class="col-4">
                          
                          <span class="fontsize14 black proximanova" >Partnership</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Location</span>
                        </div>
                        <div class="col-4">
                         
                          <span class="fontsize14 black proximanova" >Hyderabad, Telangana, India</span>
                        </div>
                      </div>
                      <div class="horizontalline mb-2 mt-3"></div>
                      <div class="d-flex">
                        <div class="mt-1 mb-1 ml-3 mr-auto">
                          <label class="fontsize14 black60 stylebold proximanova">Social Media</label>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Twitter</span>
                          <a class="fontsize14 blue proximanova">
                            <img src="../assets/twitter.svg" class="img-fluid" alt="">
                          </a>                          
                        </div>
                      </div>
                      <div class=" mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Linked in</span>
                          <a class="fontsize14 blue proximanova">
                            <img src="../assets/linkedin.svg" class="img-fluid" alt="">
                          </a>
                          
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Youtube</span>
                          <a class="fontsize14 blue proximanova"  >
                            <img src="../assets/youtube.svg" class="img-fluid" alt="">
                          </a>
                          
                        </div>
                      </div>
                    </div>   
            </div> -->
        </div>
    </div>
    
</template>
<script>
import SelecetdJobDeatils from '../components/SelectedJobDetails.vue'
import router from '../router';
export default{
    components:{
        SelecetdJobDeatils
    },
    data(){
        return{
            savedIntroVideoLink : null,
            addedSkillsList : ['java', 'html', 'css', 'javascript'],
            followersProfilePictures: [require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg')],
            jobsList : [
              {companyName : 'WorkNotion', type:'Professional Network services', city:'Boston', country : 'USA', jobTitle : 'Product Designer', jobStatus:'active'},
              {companyName : 'WorkNotion', type:'Professional Network services', city:'Boston',  country : 'USA', jobTitle : 'Frontend Developer', jobStatus:'inactive'},
              {companyName : 'WorkNotion', type:'Professional Network services', city:'Boston',  country : 'USA', jobTitle : 'Java Developer', jobStatus:'inactive'}
        ],
        }
    },    
    methods:{
        NavToJobDetails() {
            if(screen.width < 900) {
                router.push({
                    name : 'job_details'
                })
            }
            
        },
    }
}
</script>
<style scoped>
.activeBtn{
    background-color: rgba(16,163,129,0.2);
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
.profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
</style>
